import React, { useEffect } from "react";
import UpcomingScheduleCard from "../UpcomingScheduleCard";
import { useDispatch, useSelector } from "react-redux";
import { getAppointment } from "../../redux/action/Appointment";
import NoAppointments from "../NoAppointment";
import { checkFiveMinBeforeTime, getRemainingTime } from "../../utils";
import { navigateTo } from "../../utils/navigation";
import { CalendarClock, ChevronRight } from "lucide-react";

export default function Index() {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.GET_APPOINTMENT);

  const getAppointmentData = () => {
    const payload = {
      upcomingAppointment: true,
    };
    dispatch(getAppointment(payload, 3));
  };

  useEffect(() => {
    getAppointmentData();
    // const interval = setInterval(getAppointmentData, 5000);
    // return () => clearInterval(interval);
  }, []);

  const hasData = data && Object.keys(data).length > 0;

  // Flatten all appointments into a single array, sort them, and limit to 10
  const appointmentList = hasData
    ? Object.entries(data)
      .flatMap(([date, appointments]) => appointments)
      .filter(
        (item) =>
          item.status === "SCHEDULED" &&
          new Date(`${item.date}T${item.startTime}`) >= new Date()
      )
      .sort(
        (a, b) =>
          new Date(a.date + "T" + a.startTime) -
          new Date(b.date + "T" + b.startTime)
      )
      .slice(0, 10) // Take up to 10 appointments to show in scrollable container
    : [];

  return (
    <div className="bg-[#ffffff] rounded-2xl border-[1px] border-solid border-[#E2E8F0] shadow-sm h-[255px] xl:h-auto xl:absolute xl:inset-x-0 xl:top-0 xl:bottom-4 flex flex-col overflow-hidden">
      <div className="px-3 pt-3 pb-2.5 flex-shrink-0 bg-[#E7EDF5] border-b-[1px] border-solid border-x-0 border-t-0 border-[#E7EDF5]">
        <div className="flex justify-between items-center gap-2">
          <div className="flex items-center gap-2 min-w-0">
            <div className="flex items-center justify-center w-[32px] h-[32px] rounded-xl bg-white text-[#2563EB] flex-shrink-0">
              <CalendarClock size={16} />
            </div>
            <h2 className="text-[15px] font-semibold text-[#171717] font-poppins mb-0 whitespace-nowrap">
              Upcoming Schedule
            </h2>
          </div>
          <button
            className="flex items-center gap-1 flex-shrink-0 whitespace-nowrap text-[#2563EB] font-poppins text-xs font-semibold bg-white hover:bg-[#F8FAFC] rounded-full px-2.5 py-1 border-0 transition-colors"
            onClick={() =>
              navigateTo("/upcoming-appointments/upcoming")
            }
          >
            View all
            <ChevronRight size={14} />
          </button>
        </div>
      </div>
      <div className="p-2 overflow-y-auto flex-grow custom-scrollbar">
        <div className="flex flex-col gap-1">
          {loading ? (
            <p className="text-center text-gray-400 font-poppins">
              Loading upcoming schedules...
            </p>
          ) : hasData && appointmentList.length > 0 ? (
            appointmentList.map((appointment, index) => {
              return (
                <UpcomingScheduleCard
                  item={appointment}
                  key={appointment.appointmentId}
                  name={`${appointment.firstName} ${appointment.firstName === "Anonymous"
                    ? ""
                    : appointment.lastName
                    }`}
                  time={getRemainingTime(
                    appointment.date + "T" + appointment.startTime
                  )}
                  badge={appointment.mode}
                  showJoinNow={checkFiveMinBeforeTime(
                    appointment.date + "T" + appointment.startTime
                  )}
                  imgUrl={appointment.imageURL}
                  isLast={index === appointmentList.length - 1}
                />
              );
            })
          ) : (
            <NoAppointments compact />
          )}
        </div>
      </div>
    </div>
  );
}
